import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad11DRed11BBlack = () => <CrossRoad coords="2224.000000, 715.000000"/>;
export default CrossRoad11DRed11BBlack;
